import React, { useState } from 'react';
import TimeCountDown from '../countdown';
import Wordpress from '../../images/coins/wordpress.svg';
import Shopify from '../../images/coins/shopify.svg';
import Wix from '../../images/coins/wix.svg';
import Figma from '../../images/coins/figma.svg';
import Javascript from '../../images/coins/javascript.svg';
import btnMaskBg from '../../images/shapes/btn_mask_bg.png';
import counterCircle from '../../images/shapes/meme_counter_circle_shape.svg';
import shapeCartoon from '../../images/shapes/shape_cartoon_3.png';
import shapeCartoonHand from '../../images/shapes/shape_cartoon_hand.png';
import shapeNet from '../../images/shapes/shape_net.svg';
import Modal from '../Modal/Modal';

const TokenOffer = () => {

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  }

  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  return (
    <section id="id_token_offer" className="memecoin_countdown_section section_space section_decoration">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="memecoin_heading_block" data-aos="fade-up" data-aos-duration="800">
              <h2 className="heading_text text-uppercase">
                Let’s turn <mark>imaginations</mark> into reality!
              </h2>
              <p className="heading_description mb-0 pe-lg-5">
                Don’t miss the great opportunity to excel your logo and web designs. Our expert designers deliver logos and websites with perfection.
              </p>
            </div>
            <div className="coin_we_accept" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
              <h3 className="heading_text text-uppercase">We Work With</h3>
              <ul className="coins_group unordered_list">
                {[{ src: Wordpress, label: '' }, { src: Shopify, label: '' }, { src: Wix, label: '' }, { src: Figma, label: '' }, { src: Javascript, label: '' }].map((coin, index) => (
                  <li key={index}>
                    <span className="coin_icon">
                      <img src={coin.src} alt={coin.label} />
                    </span>
                    <span className="coin_label">{coin.label}</span>
                  </li>
                ))}
              </ul>
            </div>
            <button className="memecoin_btn bg-white" onClick={openModal} data-aos="fade-up" data-aos-duration="800" data-aos-delay="200">
              <span className="btn_label">Get a Free Quote</span>
              <span className="btn_bg" style={{ maskImage: `url(${btnMaskBg})` }}></span>
            </button>
          </div>
          <div className="col-lg-6" style={{zIndex:"1"}}>
            <div className="memecoin_countdown_wraper text-center">
              <div className="shape_circle">
                <img src={counterCircle} alt="Shape Circle" />
              </div>
              <div className="shape_cartoon">
                <img src={shapeCartoon} alt="Shape Cartoon" />
              </div>
              <div className="shape_cartoon_hand">
                <img src={shapeCartoonHand} alt="Shape Cartoon Hand" />
              </div>
              <div className="countdown_wrapper">
                <h3 className="heading_text text-uppercase">LET’S DESIGN YOUR BRAND NOW!</h3>
                <TimeCountDown />
                <ul className="countdown_timer_block unordered_list justify-content-center" data-countdown="2025/5/24"></ul>
              </div>
              <div className="meme_progress">
                <ul className="progress_range_step unordered_list justify-content-between">
                  <li>Slots booked</li>
                  <li>Available slots</li>
                </ul>
                <div className="progress">
                  <div className="progress-bar" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <ul className="progress_value unordered_list justify-content-center">
                  <li>We’re almost booked — secure your spot now!</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="decoration_item shape_net_top">
        <img src={shapeNet} alt="Shape Net" />
      </div>
      {isModalOpen && <Modal onClose={closeModal} />}
    </section>
  );
};

export default TokenOffer;
